import { getAvatarPath } from '@/utils/avatar'

import { TrustedContact, Recruiter } from '@/components/Job/hiring-types'

export const formatTrustedContactAsAvatar = (contact: TrustedContact) => ({
  id: contact.workerId,
  path: getAvatarPath(contact.avatar, contact.workerId),
})

export const formatRecruiterAsAvatar = (contact: Recruiter) => ({
  path: getAvatarPath(contact.avatar, contact.recruiterId),
})
